<template>
    <div>
        <ts-page-title :title="$t('serviceTicket.pageTitle')" :breadcrumb="[
            { text: $t('home'), href: '/' },
            {
                text: $t('serviceTicket.pageTitle'),
                href: '/admin/service-tickets'
            },
            {
                text: $t('create'),
                active: true
            }
        ]" />
        <ts-panel>
            <ts-panel-wrapper>
                <ts-loading-banner :loading="loading">
                    <div class="row">
                        <div class="col-md-12">
                            <Info v-model="model" :validate="errors" />
                        </div>
                    </div>
                    <div class="row ts-pt-4">
                        <div class="col-md-12">
                            <Detail v-model="model" :validate="errors" class="ts-pt-6 ts-rounded" />
                        </div>
                    </div>
                    <div class="row ts-pt-4">
                        <div class="col-md-12 ts-space-x-4 ts-flex ts-justify-end">
                            <ts-button @click.prevent="
                                $router.push({
                                    name: 'service-ticket'
                                })
                                ">{{ $t('cancel') }}</ts-button>
                            <ts-button color="primary" outline :waiting="loading" @click.prevent="onSavePreview">
                                {{ $t('savePrint') }}
                            </ts-button>
                            <ts-button color="primary" :waiting="loading" @click.prevent="onSave">
                                {{ $t('save') }}
                            </ts-button>
                        </div>
                    </div>
                </ts-loading-banner>
            </ts-panel-wrapper>
        </ts-panel>
        <a-modal :title="$t('previewPdf')" width="60%" v-model="show_pdf" :footer="null">
            <ts-preview-pdf v-model="loading" :src="src" />
        </a-modal>
    </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Info from './components/info.vue'
import Detail from './components/detail.vue'
import { mapActions, mapState } from 'vuex'

export default {
    name: 'serviceTicketCreate',
    components: {
        Detail,
        Info
    },
    data() {
        return {
            errors: new Errors(),
            loading: false,
            show_pdf: false,
            src: null,
            model: {
                service_date: moment().format('DD-MM-YYYY'),
                customer_id: null,
                ticket_owner: null,
                ticket_status_id: 1,
                priority: 'normal',
                remarks: null,
                product_list: []
            }
        }
    },
    computed: {
        ...mapState('customerService/serviceTicket', ['formViewDatas'])
    },
    methods: {
        ...mapActions('customerService/serviceTicket', ['getFormViewModel']),
        async fetchResources() {
            this.loading = true
            await this.getFormViewModel({ params: {}, index: undefined })
            this.loading = false
        },
        saveAddNew() {
            this.loading = true
            this.show_pdf = true
            this.errors = new Errors()
            this.$store
                .dispatch('customerService/serviceTicket/store',
                    Object.assign(
                        this.model, {
                        is_preview: true
                    }))
                .then(response => {
                    this.src = response.url
                    this.notice({
                        type: 'success',
                        text: response.message
                    })
                    this.clearInput()
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                    this.show_pdf = false
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onSavePreview() {
            this.loading = true
            this.show_pdf = true
            this.errors = new Errors()
            this.$store
                .dispatch('customerService/serviceTicket/store',
                    Object.assign(
                        this.model, {
                        is_preview: true
                    }))
                .then(response => {
                    this.notice({
                        type: 'success',
                        text: response.message
                    })
                    this.src = response.url
                    this.show_pdf = true
                    this.clearInput()
                })
                .catch(error => {
                    this.errors = new Errors(error.errors)
                    this.notice({ type: 'error', text: error.message })
                    this.show_pdf = false
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onSave() {
            this.loading = true
            this.errors = new Errors()
            this.$store
                .dispatch('customerService/serviceTicket/store', this.model)
                .then(response => {
                    this.notice({
                        type: 'success',
                        text: response.message
                    })
                    this.$router.push({ name: 'service-ticket' })
                })
                .catch(error => {
                    this.errors = new Errors(error.errors)
                    this.notice({ type: 'error', text: error.message })
                })
                .finally(() => {
                    this.loading = false
                })
        },
        clearInput() {
            this.errors = new Errors()
            this.model.service_date = moment().format('DD-MM-YYYY')
            this.model.customer_id = null
            this.model.ticket_owner = null
            this.model.ticket_status = 1
            this.model.priority = 'normal'
            this.model.remarks = null
            this.model.product_list = []
        },
        notice(not) {
            this.$Notice[not.type]({
                title: 'SERVICE TICKET',
                desc: not.text
            })
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetchResources()
        })
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit('customerService/serviceQuotation/RESET_STATE')
        next()
    }
}
</script>
